import {
  Component,
  Input,
  OnChanges
} from '@angular/core';

@Component({
  selector: 'axis-progressbar,[axis-progressbar]',
  templateUrl: './progressbar.component.html',
  host: {
    class: 'axis-progress'
  }
})
export class ProgressBarComponent implements OnChanges {
  @Input() ariaLabel = '';
  @Input() value = 0;
  @Input() counter = 'false';
  @Input() max: number;
  @Input() kind: string;
  @Input() status = 'false';
  progressCount = 0;
  showValueCount = false;
  currentCount = 0;
  showPercentCount = false;
  private timer: any;
  private isTimer = false;
  private showStatus = false;
  private flagFirst = true;
  @Input('data-kind')
  get dataKind(): string { return this.kind; }
  set dataKind(value: string) {
    this.kind = value;
  }
  ngOnChanges() {
    if (this.flagFirst) {
      setTimeout(() => {
        this.visibleProgressCounter(this.counter);
        this.flagFirst = false;
      }, 0);
    } else {
      this.visibleProgressCounter(this.counter);
    }
  }

  visibleProgressCounter = (counter: string): void => {
    if (counter === 'true' && this.max) {
      this.showValueCount = true;
      if (this.kind) {
        this.enableCancelFeature();
      } else {
        this.progressCount = (this.value / this.max) * 100;
        this.currentCount = this.value;
      }
    } else if (counter === 'percent') {
      this.showPercentCount = true;
      if (this.kind) {
        this.enableCancelFeature();
      } else {
        this.progressCount = this.value;
        this.currentCount = this.value;
      }
    } else {
      this.showPercentCount = false;
      this.showValueCount = false;
      this.progressCount = this.value;
      this.currentCount = this.value;
    }
    const max = this.max ?  this.max : '100';
    this.ariaLabel = 'A progress bar bound from 0 to ' + max;
  };

  enableCancelFeature = (): void => {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.kind === 'cancel') {
      this.showStatus = false;
      let temp = 0;
      this.timer = setInterval(() => {
        if (temp < this.value) {
          this.isTimer = true;
          ++temp;
          this.progressCount = temp;
          this.currentCount = temp;
        } else {
          this.isTimer = false;
          if (this.status === 'true') {
            this.showStatus = true;
          }
        }
      }, 50);
    }
  };

  cancelProgressBar = (): void => {
    if (this.isTimer) {
      clearInterval(this.timer);
      if (this.status === 'true') {
        this.showStatus = true;
      } else {
        this.showStatus = false;
      }
    }
  };
}
